import { CONFIG_BUY_NOW_REDIR_DOMAIN } from '@src/config/env'
import { getStorage } from '@src/utils/enhancedStorage'

import AuthUtil from '../../utils/authUtil'
import isBrowser from '../../utils/isBrowser'
import { getCartWithId, getIsCartActive } from '../cartService/cart.service'
import { removeCartIdFromLocalStorage } from '../cartService/cart.service.helper'
import { TBuyNowApiResponse } from '../cartService/cart.service.types'

import { createLocalePrefixedCheckoutUrl } from './checkoutUrl.helper'
import {
  LOCAL_STORAGE_CART_OBJ_KEY,
  LOCAL_STORAGE_NEW_CART_ID_KEY,
  LOCAL_STORAGE_PREV_CART_ID_KEY,
} from './new-checkout.constants'

export const updateNewCheckoutInLocalStorage = (cart: any) => {
  if (cart?.id) {
    getStorage().setItem(LOCAL_STORAGE_NEW_CART_ID_KEY, cart.id || '', { isGlobal: false })
    getStorage().setItem(LOCAL_STORAGE_CART_OBJ_KEY, JSON.stringify(cart), { isGlobal: false })
  }
}
export const getPrevCheckoutId = () => {
  return getStorage().getItem<string>(LOCAL_STORAGE_PREV_CART_ID_KEY, { isGlobal: false })
}
export const deletePrevCheckoutId = () => {
  getStorage().removeItem(LOCAL_STORAGE_PREV_CART_ID_KEY, { isGlobal: false })
}
export const getCheckoutId = () => {
  return getStorage().getItem<string>(LOCAL_STORAGE_NEW_CART_ID_KEY, { isGlobal: false })
}
export const getNewCheckoutFromLocalStorage = () => {
  let cartString: string | null = ''
  if (isBrowser()) {
    if (getStorage().getItem<string>(LOCAL_STORAGE_NEW_CART_ID_KEY, { isGlobal: false })) {
      cartString = getStorage().getItem<string>(LOCAL_STORAGE_CART_OBJ_KEY, { isGlobal: false })
    } else {
      getStorage().removeItem(LOCAL_STORAGE_CART_OBJ_KEY, { isGlobal: false })
    }
  }
  let checkout
  if (cartString) {
    try {
      checkout = JSON.parse(cartString)
    } catch (error) {
      console.error('Error occured on getCheckoutFromLocalStorage: ', error)
    }
  }
  return checkout
}
export const getNewCartData = async () => {
  const isLoggedIn = AuthUtil.isLoggedIn()
  let result = []
  if (isLoggedIn) {
    const data = await getIsCartActive()
    result = data
  } else {
    const cartId = getCheckoutId()
    if (cartId) {
      const data = await getCartWithId(cartId)
      if (data?.cartStatus !== 'ACTIVE') {
        removeCartIdFromLocalStorage()
        return
      }
      result = data
    }
  }
  return result
}

export const getCheckoutUrlFromBuyNowRes = (
  response: TBuyNowApiResponse | undefined,
  showNewDesign: boolean,
  isI18nPreviewEnabled: boolean,
  appendLoaderRedesign = false,
  loaderRedesignIsLoggedIn?: boolean,
) => {
  if (!response?.buyNowCartCheckoutMapping) return ''
  const {
    buyNowCartCheckoutMapping: { checkoutId, checkoutAuthCode },
  } = response

  if (!checkoutId || !checkoutAuthCode) return ''

  // Create locale-prefixed checkout URL
  return createLocalePrefixedCheckoutUrl(
    CONFIG_BUY_NOW_REDIR_DOMAIN,
    checkoutId,
    checkoutAuthCode,
    showNewDesign,
    isI18nPreviewEnabled,
    false,
    undefined,
    appendLoaderRedesign,
    loaderRedesignIsLoggedIn,
  )
}
